import styled from 'styled-components';
export const Button = styled.button`
  &:hover {
    opacity: 0.7;
  }
  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.colorPrimary};
  text-transform: uppercase;
  padding: 0.7em;
  outline: none;
  border: none;
  color: white;
  width: 100%;
`;
